import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '@/App';
import { toast } from 'sonner';

const BACKEND_URL = window.__BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const GoogleCallback = () => {
  const { checkAuth } = React.useContext(AuthContext);
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const processGoogleAuth = async () => {
      // Get session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        setError('No session ID found');
        toast.error('Authentication failed');
        setTimeout(() => navigate('/login'), 2000);
        return;
      }

      try {
        // Exchange session_id for user data
        await axios.post(
          `${API}/auth/google/callback`,
          {},
          {
            headers: { 'X-Session-ID': sessionId },
            withCredentials: true
          }
        );

        // Refresh auth state
        await checkAuth();
        toast.success('Successfully signed in!');
        
        // Clean URL and redirect
        window.history.replaceState({}, document.title, '/dashboard');
        navigate('/dashboard');
      } catch (error) {
        console.error('Google auth error:', error);
        setError(error.response?.data?.detail || 'Authentication failed');
        toast.error('Authentication failed');
        setTimeout(() => navigate('/login'), 2000);
      }
    };

    processGoogleAuth();
  }, [checkAuth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#121417]">
      <div className="text-center">
        {error ? (
          <div>
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#FF4F4F]/20 flex items-center justify-center">
              <svg className="w-8 h-8 text-[#FF4F4F]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <p className="text-[#FF4F4F] text-lg font-medium">{error}</p>
            <p className="text-[#8A93A6] mt-2">Redirecting to login...</p>
          </div>
        ) : (
          <div>
            <div className="w-16 h-16 mx-auto mb-4 border-4 border-[#3A7BFF] border-t-transparent rounded-full animate-spin"></div>
            <p className="text-white text-lg font-medium">Completing sign in...</p>
            <p className="text-[#8A93A6] mt-2">Please wait a moment</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default GoogleCallback;
